import moment from 'moment';
import { toNumber, get } from 'lodash';
import { humanize } from '@utils';
import { getTextColor } from '@src/utils/kpi/tools';
import { getNewAppVersion } from '@api/autoInsights';
import { METRIC_NEWAPP_VERSION } from '@utils/constants';
import { formatDate } from './formatter';
import { MAX_LIMIT } from './Insights';

const TS_FORMAT = 'MMM DD HH:mm';

// round off to nearest day or hour
export const getEndTime = (arg = 'day') => {
  if (arg === 'hour') {
    return moment().startOf('hour').format();
  }
  return moment().subtract(1, 'day').endOf('day').format();
};

export const getDisplayInterval = (duration) => {
  const to = moment(getEndTime('hour'));
  const from = moment(to).subtract(duration, 'days');

  return {
    from: from.format(TS_FORMAT),
    to: to.format(TS_FORMAT),
  };
};

export const humanizeValue = (value) => {
  return humanize(value, '');
};

export const getSpiText = (value) => {
  return getTextColor(humanizeValue(toNumber(value)));
};

export async function generateNewAppVersionExportData() {
  const to = getEndTime('hour');
  const resp = await getNewAppVersion({
    params: {
      to,
      limit: MAX_LIMIT,
    },
  });

  const { versionData = [] } = get(resp, 'data.response.newVersionData', {});

  const config = {
    page: {
      key: 'new-app-version',
      title: 'New App Version',
    },
    sections: [
      {
        key: 'new-app-version',
        title: 'New App Version',
      },
    ],
  };

  const exportData = {
    sections: {
      'new-app-version': {
        'new-app-version': {
          data: versionData.reduce((res, item) => {
            const { newVersion, oldVersion } = item;
            const newDims = newVersion.dimensions;
            const oldDims = oldVersion.dimensions;
            const newMetrics = newVersion.metrics;
            const oldMetrics = oldVersion.metrics;
            const newVersionData = {
              exportReleaseDate: formatDate(newVersion.releaseDate) || '',
              exportAppName: newDims[METRIC_NEWAPP_VERSION],
              exportAppVersion: Object.values(newDims)[1] || '',
              exportSPIStream: humanizeValue(newMetrics.SpiStreams),
              exportSPI: humanizeValue(newMetrics.StreamingPerformanceIndex),
            };
            const oldVersionData = {
              exportReleaseDate: '',
              exportAppName: oldDims[METRIC_NEWAPP_VERSION],
              exportAppVersion: Object.values(oldDims)[1] || '',
              exportSPIStream: humanizeValue(oldMetrics.SpiStreams),
              exportSPI: humanizeValue(oldMetrics.StreamingPerformanceIndex),
            };

            res.push(newVersionData, oldVersionData, {
              exportReleaseDate: '',
              exportAppName: '',
              exportAppVersion: '',
              exportSPIStream: '',
              exportSPI: '',
            });

            return res;
          }, []),
          headers: [
            {
              title: 'Release Date',
              key: 'exportReleaseDate',
            },
            {
              title: 'App Name',
              key: 'exportAppName',
            },
            {
              title: 'App Version',
              key: 'exportAppVersion',
            },
            {
              title: 'SPI Stream',
              key: 'exportSPIStream',
            },
            {
              title: 'SPI',
              key: 'exportSPI',
            },
          ],
          widgetInfo: {
            title: `Auto Insights New App Version Export ${to}`,
          },
        },
      },
    },
  };

  return {
    config,
    exportData,
  };
}
